import React from "react";
import Image from "next/image";
import { useSelector } from "react-redux";

type ProfileRowProps = {
  label: string;
  value: string;
};

const ProfileRow = ({ label, value }: ProfileRowProps) => {
  return (
    <div className="border border-[#EEEEEE] bg-white rounded-md px-3 py-2">
      <p className="text-[10px] uppercase tracking-wide text-[#8A8A8A]">
        {label}
      </p>
      <p className="text-sm text-[#111111] mt-1 break-words">{value || "—"}</p>
    </div>
  );
};

export default function SellerProfile() {
  const user = useSelector((state: any) => state.buyerAuth?.user);

  const attributes = Array.isArray(user?.attributes) ? user.attributes : [];
  const attrMap = attributes.reduce(
    (acc: Record<string, string>, item: any) => {
      if (item?.type) {
        acc[item.type] = item?.value || "";
      }
      return acc;
    },
    {},
  );

  const profile = user?.profile || {};
  const bio = profile?.bio || {};
  const userDetails = profile?.meta?.user_details || {};

  const name =
    bio?.full_name ||
    [bio?.first_name, bio?.last_name].filter(Boolean).join(" ") ||
    userDetails?.name ||
    "User";
  const email = attrMap.email || bio?.email || "";
  const mobile = attrMap.mobile_number || userDetails?.mobile_number || "";
  const address = userDetails?.address || bio?.address || "";
  const userType =
    userDetails?.user_type?.value ||
    userDetails?.user_type ||
    attrMap.user_type;
  const pan = userDetails?.pan_number || userDetails?.pan || "";
  const gst = userDetails?.gst_number || "";
  const aadhaar =
    userDetails?.aadhar_number || userDetails?.aadhaar_number || "";
  const companyName =
    userDetails?.company_name ||
    userDetails?.business_name ||
    profile?.name ||
    "";
  const profilePicture = profile?.profile_picture;
  const imagixBaseUrl = process.env.NEXT_PUBLIC_IMAGIX_URL ?? "";
  const profileImageSrc =
    profilePicture && imagixBaseUrl
      ? `${imagixBaseUrl}/${profilePicture}?fit=crop&w=220&h=220&auto=format`
      : "";

  return (
    <div className="px-4 py-5 lg:px-6 lg:py-6">
      <div className="bg-white border border-[#EEEEEE] rounded-md shadow-sm p-4 lg:p-5">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-b border-[#EFEFEF] pb-4">
          <div className="flex items-center gap-3">
            <div className="w-[64px] h-[64px] rounded-full bg-[#F3F3F3] overflow-hidden flex items-center justify-center">
              {profileImageSrc ? (
                <Image
                  src={profileImageSrc}
                  alt={`${name} profile`}
                  width={64}
                  height={64}
                  unoptimized
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-xl font-semibold text-[#6B7280]">
                  {name?.charAt(0)?.toUpperCase() || "U"}
                </span>
              )}
            </div>
            <div>
              <h2 className="text-lg lg:text-xl font-semibold text-[#111111]">
                {name}
              </h2>
            </div>
          </div>
          {/* <div className="text-xs text-[#f5761a] font-semibold">ID: {user?.uuid || "—"}</div> */}
        </div>

        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          <ProfileRow label="Email" value={email} />
          <ProfileRow label="Mobile Number" value={mobile} />
          <ProfileRow label="User Type" value={userType || ""} />
          <ProfileRow label="Address" value={address} />
          <ProfileRow label="PAN Number" value={pan} />
          <ProfileRow label="GST Number" value={gst} />
          <ProfileRow label="Aadhaar Number" value={aadhaar} />
          <ProfileRow label="Company Name" value={companyName} />
        </div>
      </div>
    </div>
  );
}
